"use strict";

var _aphrodite = require("aphrodite");

exports.onClientEntry = function () {
  if (window.gatsbyAphrodite) {
    _aphrodite.StyleSheet.rehydrate(window.gatsbyAphrodite);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-aphrodite/gatsby-browser.js
// module id = 340
// module chunks = 231608221292675